module.exports = __webpack_public_path__ + "img/pleisure_bodyimage02.4806aece.jpg";